import { useState } from "react";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Divider,
  IconButton,
  styled,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";

import { Column } from "../../components/tables/interfaces";
import {
  V1EventType,
  V1GetWorkflowExecutionHistoryReverseResponse,
  V1PendingActivityInfo,
  V1WorkflowExecutionStatus
} from "../../services/workflow-server";
import { ExpandMore, Refresh } from "@mui/icons-material";

export type TabOption = "compact" | "detailed" | "json" | "download";

export type workflowExecutionStartedType = "Summary" | "Parent" | "Task Queue" | "Workflow";

export type activityTaskScheduledTabType = "Summary" | "Task Queue" | "Schedule" | "Retry Policy";

type getOrCreateExpType = "ActivityTaskCompleted" | "ActivityTaskStarted" | "ActivityTaskScheduled" | "ActivityTaskFailed";

interface RenderCompactProps {
  eventsData: V1GetWorkflowExecutionHistoryReverseResponse;
  selectedRowId: string;
}

export interface LabelWithValueProps {
  label: string;
  value: any;
}

export interface V1HistoryEvent {
  eventId: string;
  eventTime: string;
  eventType: string;
  workflowExecutionCompletedEventAttributes?: any;
  workflowTaskCompletedEventAttributes?: any;
  workflowTaskStartedEventAttributes?: any;
  workflowTaskScheduledEventAttributes?: any;
  activityTaskFailedEventAttributes?: any;
  activityTaskCompletedEventAttributes?: any;
  activityTaskStartedEventAttributes?: any;
  activityTaskScheduledEventAttributes?: any;
  workflowExecutionStartedEventAttributes?: any;
  workflowExecutionTerminatedEventAttributes?: any;
  workflowExecutionFailedEventAttributes?: any;
  workflowTaskFailedEventAttributes?: any;
  workflowTaskTimedOutEventAttributes?: any;
}

export const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
  borderRadius: 2,
  border: "1px solid #ddd",
  transition: "background-color 0.3s, color 0.3s, transform 0.2s",
  "&.Mui-selected": {
    backgroundColor: "#000",
    color: "#fff",
    borderColor: "#000",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
  "&:not(:first-of-type)": {
    borderLeft: "none",
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.2rem",
    marginRight: theme.spacing(0.5),
  },
}));

export const CustomToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    backgroundColor: "#fff",
    borderRadius: 2,
    overflow: "hidden",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    "& .MuiToggleButton-root": {
      padding: theme.spacing(1, 2),
      display: "flex",
      alignItems: "center",
    },
  })
);

export const InputOutputBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  border: "1px solid grey",
  justifyContent: "space-between",
  borderRadius: 2,
  margin: theme.spacing(2),
  cursor: "pointer",
}));

export const InputTypography = styled(Typography)(({ theme }) => ({
  whiteSpace: "pre-wrap",
  color: "white",
  overflow: "auto",
  padding: theme.spacing(2),
  // paddingTop: theme.spacing(1),
  // paddingBottom: theme.spacing(1),
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.grey[500],
    borderRadius: 2,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: theme.palette.grey[700],
  },
}));

export const CustomBoxForInput = styled(Box)(({ theme }) => ({
  position: "relative",
  // border: '1px solid grey',
  backgroundColor: "black",
  padding: theme.spacing(2),
  marginTop: theme.spacing(2),
  maxHeight: "60vh",
  maxWidth: "60vw",
  overflowY: "auto",
  overflowX: "auto",
  margin: theme.spacing(1),
  borderRadius: 2,
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.grey[500],
    borderRadius: 8,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: theme.palette.grey[700],
  },
}));

export const CustomBoxForOutput = styled(Box)(({ theme }) => ({
  position: "relative",
  border: "1px solid grey",
  backgroundColor: "black",
  padding: theme.spacing(2),
  // marginTop: theme.spacing(2),
  height: "320px",
  // maxWidth: "30vw",
  overflowY: "auto",
  overflowX: "auto",
  // margin: theme.spacing(1),
  borderRadius: 2,
}));

export const CustomBigBox = styled(Box)(({ theme }) => ({
  position: "relative",
  border: "1px solid grey",
  backgroundColor: "black",
  height: '320px',
  // maxWidth: "90vw",
  overflowY: 'auto',
  overflowX: 'auto',
  // margin: theme.spacing(1),
  borderRadius: 2,
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.grey[500],
    borderRadius: 8,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: theme.palette.grey[700],
  },
}));

export const CustomInputOuputBox = styled(Box)(({ theme }) => ({
  position: "relative",
  // border: '1px solid grey',
  padding: theme.spacing(2),
  marginTop: theme.spacing(2),
  height: "30vh",
  maxWidth: "90vw",
  overflowY: "auto",
  overflowX: "auto",
  margin: theme.spacing(2),
  borderRadius: 2,
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.grey[500],
    borderRadius: 8,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: theme.palette.grey[700],
  },
}));

export const CustomFailurBox = styled(Box)(({ theme }) => ({
  position: "relative",
  // border: '1px solid grey',
  padding: theme.spacing(2),
  marginTop: theme.spacing(2),
  height: "30vh",
  maxWidth: "700px",
  overflowY: "auto",
  overflowX: "auto",
  margin: theme.spacing(2),
  borderRadius: 2,
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.grey[500],
    borderRadius: 8,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: theme.palette.grey[700],
  },
}));

export const CustomJSONBox = styled(Box)(({ theme }) => ({
  position: "relative",
  // border: '1px solid grey',
  padding: theme.spacing(2),
  marginTop: theme.spacing(2),
  height: "60vh",
  maxWidth: "90vw",
  overflowY: "auto",
  overflowX: "auto",
  margin: theme.spacing(2),
  borderRadius: 2,
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.grey[500],
    borderRadius: 8,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: theme.palette.grey[700],
  },
}));

export const CustomIconButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: 8,
  right: 8,
  zIndex: 1,
  color: "whitesmoke",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
  },
}));

export const ClickableBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(1),
  marginRight: theme.spacing(1),
  cursor: "pointer",
  borderBottom: "3px solid transparent",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: theme.palette.grey[200],
  },
  "&.selected": {
    backgroundColor: theme.palette.grey[400],
    borderBottom: `3px solid ${theme.palette.primary.main}`,
  },
}));

export const eventAttributesMap: { [key: string]: keyof V1HistoryEvent } = {
  WorkflowExecutionCompleted: "workflowExecutionCompletedEventAttributes",
  WorkflowExecutionStarted: "workflowExecutionStartedEventAttributes",
  WorkflowExecutionTerminated: "workflowExecutionTerminatedEventAttributes",
  WorkflowExecutionFailed: "workflowExecutionFailedEventAttributes",
  WorkflowTaskCompleted: "workflowTaskCompletedEventAttributes",
  WorkflowTaskStarted: "workflowTaskStartedEventAttributes",
  WorkflowTaskScheduled: "workflowTaskScheduledEventAttributes",
  WorkflowTaskTimedOut: "workflowTaskTimedOutEventAttributes",
  WorkflowTaskFailed: "workflowTaskFailedEventAttributes",
  ActivityTaskFailed: "activityTaskFailedEventAttributes",
  ActivityTaskCompleted: "activityTaskCompletedEventAttributes",
  ActivityTaskStarted: "activityTaskStartedEventAttributes",
  ActivityTaskScheduled: "activityTaskScheduledEventAttributes",
};

export const columnsEventsReverse: Column[] = [
  { id: "id", label: "ID", type: "string" },
  { id: "eventTime", label: "Event Time", type: "datetime" },
  {
    id: "status",
    label: "Status",
    render: (value: any) => {
      return value.replace(/([A-Z])/g, " $1").trim();
    },
  },
];

export const columnsEventForCompact: Column[] = [
  { id: "id", label: "ID", type: "string" },
  { id: "eventTime", label: "Event Time", type: "datetime" },
  {
    id: "status",
    label: "Event Time",
    render: (value: any) => {
      return value
        .replace(/_/g, " ")
        .replace(/([A-Z])/g, " $1")
        .replace(/\b\w/g, (char: string) => char.toUpperCase())
        .trim();
    },
  },
];

export const getRowColor = (row: any) => {
  switch (row.status) {
    case V1EventType.WORKFLOW_EXECUTION_FAILED:
    case V1EventType.WORKFLOW_TASK_FAILED:
    case V1EventType.ACTIVITY_TASK_FAILED:
    case V1EventType.REQUEST_CANCEL_EXTERNAL_WORKFLOW_FAILED:
    case V1EventType.START_CHILD_WORKFLOW_FAILED:
    case V1EventType.SIGNAL_EXTERNAL_WORKFLOW_FAILED:
    case V1EventType.CHILD_WORKFLOW_FAILED:
    case V1EventType.WORKFLOW_EXECUTION_UPDATE_REJECTED:
      return "rgba(244, 67, 54, 0.1)"; // Red for errors

    case V1EventType.WORKFLOW_EXECUTION_TIMED_OUT:
    case V1EventType.WORKFLOW_TASK_TIMED_OUT:
    case V1EventType.ACTIVITY_TASK_TIMED_OUT:
    case V1EventType.CHILD_WORKFLOW_TIMED_OUT:
      return "rgba(255, 152, 0, 0.1)"; // Orange for timeouts

    case V1EventType.WORKFLOW_EXECUTION_CANCELED:
    case V1EventType.ACTIVITY_TASK_CANCELED:
    case V1EventType.CHILD_WORKFLOW_CANCELED:
    case V1EventType.WORKFLOW_EXECUTION_TERMINATED:
    case V1EventType.CHILD_WORKFLOW_TERMINATED:
      return "rgba(255, 152, 0, 0.1)"; // Orange for canceled/terminated

    // case V1EventType.WORKFLOW_EXECUTION_COMPLETED:
    // case V1EventType.WORKFLOW_TASK_COMPLETED:
    // case V1EventType.ACTIVITY_TASK_COMPLETED:
    // case V1EventType.CHILD_WORKFLOW_COMPLETED:
    //     return 'rgba(76, 175, 80, 0.1)'; // Green for success

    default:
      return "inherit"; // Default color
  }
};

export const handleCopy = (text: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      console.log("Content copied to clipboard");
    })
    .catch((err) => {
      console.error("Failed to copy content: ", err);
    });
};

export const LabelWithValue: React.FC<LabelWithValueProps> = ({
  label,
  value,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "8px 0",
      }}
    >
      <Typography sx={{ fontWeight: "bold" }}>{label}</Typography>
      <Typography sx={{ fontWeight: "bolder" }}>{value}</Typography>
    </Box>
  );
};

export const renderTabContentForWorkflowExecutionScheduled = (
  attributes: any,
  workflowExecutionStartedTab: workflowExecutionStartedType
) => {
  switch (workflowExecutionStartedTab) {
    case "Summary":
      return (
        <Box>
          <LabelWithValue
            label="Start To Close Timeout"
            value={attributes?.startToCloseTimeout}
          />
          <Divider />
          <LabelWithValue label="Attempt" value={attributes?.attempt} />
        </Box>
      );

    case "Task Queue":
      return (
        <Box>
          <LabelWithValue
            label="Task Queue Name"
            value={attributes?.taskQueue?.name}
          />
          <Divider />
          <LabelWithValue
            label="Task Queue Kind"
            value={attributes?.taskQueue?.kind}
          />
        </Box>
      );
  }
};

export const RenderContentForWorkflowExecutionStarted: React.FC<{attributes: any, InputData: string[]}> = ({attributes, InputData}) => {
  const [workflowExecutionStartedTab, setWorkflowExecutionStartedTab] = useState<workflowExecutionStartedType>("Summary");

  const handleWorkflowExecutionStartedTabChange = (
    event: React.SyntheticEvent,
    newValue: workflowExecutionStartedType
  ) => {
    setWorkflowExecutionStartedTab(newValue);
  };

  return (
    <Box>
      <Tabs
        value={workflowExecutionStartedTab}
        onChange={handleWorkflowExecutionStartedTabChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
      >
        <Tab value="Summary" label="Summary" />
        <Tab value="Parent" label="Parent" />
        <Tab value="Task Queue" label="Task Queue" />
        <Tab value="Workflow" label="Workflow" />
      </Tabs>
      <Box mt={2}>
        {renderTabContentForWorkflowExecutionStarted(
          attributes,
          workflowExecutionStartedTab,
          InputData || []
        )}
      </Box>
    </Box>
  );
};

export const renderTabContentForWorkflowExecutionStarted = (
  attributes: any,
  workflowExecutionStartedTab: workflowExecutionStartedType,
  InputData: string[]
) => {
  switch (workflowExecutionStartedTab) {
    case "Summary":
      return (
        <Box>
          <Typography sx={{ fontWeight: "bold" }}>Input</Typography>
          <Box
            sx={{
              backgroundColor: "black",
              m: 1,
              position: "relative",
              borderRadius: 2,
              maxWidth: "60vw",
              border: "1px solid grey",
            }}
          >
            <CustomIconButton
              onClick={() => {
                handleCopy(JSON.stringify(InputData, null, 2));
              }}
            >
              <ContentCopyIcon />
            </CustomIconButton>
            <CustomBoxForInput>
              <Typography
                component="pre"
                sx={{ whiteSpace: "pre-wrap", color: "white" }}
              >
                {JSON.stringify(InputData, null, 2)}
              </Typography>
            </CustomBoxForInput>
          </Box>
          <Divider />
          <LabelWithValue
            label="Original Execution Run ID"
            value={attributes?.originalExecutionRunId}
          />
          <Divider />
          <LabelWithValue label="Identity" value={attributes?.identity} />
          <Divider />
          <LabelWithValue
            label="First Execution Run ID"
            value={attributes?.firstExecutionRunId}
          />
          <Divider />
          <LabelWithValue label="Attempt" value={attributes?.attempt} />
        </Box>
      );

    case "Parent":
      return (
        <Box>
          <LabelWithValue
            label="Parent Initiated Event ID"
            value={attributes?.parentInitiatedEventId}
          />
          <Divider />
          <LabelWithValue
            label="Parent Initiated Event Version"
            value={attributes?.parentInitiatedEventVersion}
          />
        </Box>
      );

    case "Task Queue":
      return (
        <Box>
          <LabelWithValue
            label="Task Queue Name"
            value={attributes?.taskQueue?.name}
          />
          <Divider />
          <LabelWithValue
            label="Task Queue Kind"
            value={attributes?.taskQueue?.kind}
          />
        </Box>
      );

    case "Workflow":
      return (
        <Box>
          <LabelWithValue
            label="Workflow Type Name"
            value={attributes?.workflowType?.name}
          />
          <Divider />
          <LabelWithValue
            label="Workflow Task Timeout"
            value={attributes?.workflowTaskTimeout}
          />
        </Box>
      );
  }
};

export const renderworkflowExecutionTerminated = (attributes: any) => {
  return <Box>
    <LabelWithValue
      label="Reason"
      value={attributes?.reason}
    />
    <Divider />
    <LabelWithValue
      label="Identity"
      value={attributes?.identity}
    />
  </Box>
}

export const RenderContentForWorkflowTaskScheduled: React.FC<{attributes: any}> = ({attributes}) => {
  const [workflowExecutionStartedTab, setWorkflowExecutionStartedTab] = useState<workflowExecutionStartedType>("Summary");
  const handleWorkflowExecutionStartedTabChange = (
    event: React.SyntheticEvent,
    newValue: workflowExecutionStartedType
  ) => {
    setWorkflowExecutionStartedTab(newValue);
  };
  return (
    <Box>
      <Tabs
        value={workflowExecutionStartedTab}
        onChange={handleWorkflowExecutionStartedTabChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
      >
        <Tab value="Summary" label="Summary" />
        <Tab value="Task Queue" label="Task Queue" />
      </Tabs>
      <Box mt={2}>
        {renderTabContentForWorkflowExecutionScheduled(
          attributes,
          workflowExecutionStartedTab
        )}
      </Box>
    </Box>
  );
};

export const renderworkflowTaskTimeout = (attributes: any) => {
  return <Box>
    <LabelWithValue
      label="Scheduled Event ID"
      value={attributes?.scheduledEventId}
    />
    <Divider />
    <LabelWithValue
      label="Started Event ID"
      value={attributes?.startedEventId}
    />
    <LabelWithValue
      label="Timeout Type"
      value={attributes?.timeoutType}
    />
  </Box>
}

export const renderworkflowExecutionFailed = (attributes: any) => {
  return <Box>
    <Box sx={{display: "flex", gap: 2}}>
      <Box
        sx={{
          backgroundColor: "black",
          m: 1,
          position: "relative",
          borderRadius: 2,
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontWeight: "bold",
            margin: 1,
          }}
        >
          Failure
        </Typography>
        <CustomIconButton
          onClick={() => {
            handleCopy(JSON.stringify(attributes?.failure, null, 2));
          }}
          sx={{ position: "absolute", top: 8, right: 8, mr: 2 }}
        >
          <ContentCopyIcon />
        </CustomIconButton>
        <CustomFailurBox>
          <Typography
            variant="body2"
            component="pre"
            sx={{ color: "white" }}
          >
            {JSON.stringify(attributes?.failure, null, 2)}
          </Typography>
        </CustomFailurBox>
      </Box>
      <Box
        sx={{
          backgroundColor: "black",
          m: 1,
          position: "relative",
          borderRadius: 2,
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontWeight: "bold",
            margin: 1,
          }}
        >
          Stack Trace
        </Typography>
        <CustomIconButton
          onClick={() => {
            handleCopy( 
              attributes?.failure?.stackTrace?.replace(/\\n/g, '\n') || 
              attributes?.failure?.cause?.stackTrace.replace(/\\n/g, '\n') || "");
          }}
          sx={{ position: "absolute", top: 8, right: 8, mr: 2 }}
        >
          <ContentCopyIcon />
        </CustomIconButton>
        <CustomFailurBox>
          <Typography
            variant="body2"
            component="pre"
            sx={{ color: "white" }}
          >
            {
            attributes?.failure?.stackTrace?.replace(/\\n/g, '\n') || 
            attributes?.failure?.cause?.stackTrace.replace(/\\n/g, '\n') || ""}
          </Typography>
        </CustomFailurBox>
      </Box>
    </Box>
    <Divider />
    <LabelWithValue
      label="Retry State"
      value={attributes?.retryState}
    />
    <Divider />
    <LabelWithValue
      label="Workflow Task Completed Event ID"
      value={attributes?.workflowTaskCompletedEventId}
    />
  </Box>
}

export const renderWorkflowTaskFailed = (attributes: any) => {
  return <Box>
    <LabelWithValue
      label="Scheduled Event ID"
      value={attributes?.scheduledEventId}
    />
    <Divider />
    <LabelWithValue
      label="Started Event ID"
      value={attributes?.startedEventId}
    />
    <LabelWithValue
      label="Cause"
      value={attributes?.cause}
    />
    <Divider />
    <Box sx={{display: "flex", gap: 2}}>
      <Box
        sx={{
          backgroundColor: "black",
          m: 1,
          position: "relative",
          borderRadius: 2,
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontWeight: "bold",
            margin: 1,
          }}
        >
          Failure
        </Typography>
        <CustomIconButton
          onClick={() => {
            handleCopy(JSON.stringify(attributes?.failure, null, 2));
          }}
          sx={{ position: "absolute", top: 8, right: 8, mr: 2 }}
        >
          <ContentCopyIcon />
        </CustomIconButton>
        <CustomFailurBox>
          <Typography
            variant="body2"
            component="pre"
            sx={{ color: "white" }}
          >
            {JSON.stringify(attributes?.failure, null, 2)}
          </Typography>
        </CustomFailurBox>
      </Box>
      <Box
        sx={{
          backgroundColor: "black",
          m: 1,
          position: "relative",
          borderRadius: 2,
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontWeight: "bold",
            margin: 1,
          }}
        >
          Stack Trace
        </Typography>
        <CustomIconButton
          onClick={() => {
            handleCopy(attributes?.failure?.stackTrace?.replace(/\\n/g, '\n'));
          }}
          sx={{ position: "absolute", top: 8, right: 8, mr: 2 }}
        >
          <ContentCopyIcon />
        </CustomIconButton>
        <CustomFailurBox>
          <Typography
            variant="body2"
            component="pre"
            sx={{ color: "white" }}
          >
            {attributes?.failure?.stackTrace?.replace(/\\n/g, '\n')}
          </Typography>
        </CustomFailurBox>
      </Box>
    </Box>
    <Divider />
    <LabelWithValue
      label="Identity"
      value={attributes?.identity}
    />
    <Divider />
    <LabelWithValue
      label="Fork Event Version"
      value={attributes?.forkEventVersion}
    />
  </Box>
}

export const renderActivityTaskFailed = (attributes: any, eventTime: string) => {
  return <Box>
    <LabelWithValue
      label="Event Time"
      value={`${new Date(eventTime).toUTCString()}`}
    />
    <Divider />
    <Box sx={{display: "flex", gap: 2}}>
      <Box
        sx={{
          backgroundColor: "black",
          m: 1,
          position: "relative",
          borderRadius: 2,
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontWeight: "bold",
            margin: 1,
          }}
        >
          Failure
        </Typography>
        <CustomIconButton
          onClick={() => {
            handleCopy(JSON.stringify(attributes?.failure, null, 2));
          }}
          sx={{ position: "absolute", top: 8, right: 8, mr: 2 }}
        >
          <ContentCopyIcon />
        </CustomIconButton>
        <CustomFailurBox>
          <Typography
            variant="body2"
            component="pre"
            sx={{ color: "white" }}
          >
            {JSON.stringify(attributes?.failure, null, 2)}
          </Typography>
        </CustomFailurBox>
      </Box>
      <Box
        sx={{
          backgroundColor: "black",
          m: 1,
          position: "relative",
          borderRadius: 2,
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontWeight: "bold",
            margin: 1,
          }}
        >
          Stack Trace
        </Typography>
        <CustomIconButton
          onClick={() => {
            handleCopy(attributes?.failure?.stackTrace?.replace(/\\n/g, '\n'));
          }}
          sx={{ position: "absolute", top: 8, right: 8, mr: 2 }}
        >
          <ContentCopyIcon />
        </CustomIconButton>
        <CustomFailurBox>
          <Typography
            variant="body2"
            component="pre"
            sx={{ color: "white" }}
          >
            {attributes?.failure?.stackTrace?.replace(/\\n/g, '\n')}
          </Typography>
        </CustomFailurBox>
      </Box>
    </Box>
    <Divider />
    <LabelWithValue
      label="Scheduled Event ID"
      value={attributes?.scheduledEventId}
    />
    <Divider />
    <LabelWithValue
      label="Started Event ID"
      value={attributes?.startedEventId}
    />
    <Divider />
    <LabelWithValue
      label="Identity"
      value={attributes?.identity}
    />
    <Divider />
    <LabelWithValue
      label="Retry State"
      value={attributes?.retryState}
    />
  </Box>
}

export const renderTabContentForActivityTaskScheduledTab = (
  attributes: any,
  activityTaskScheduledTab: activityTaskScheduledTabType,
  InputData: string[]
) => {
  switch (activityTaskScheduledTab) {
    case "Summary":
      return (
        <Box>
          <LabelWithValue label="Activity ID" value={attributes?.activityId} />
          <Divider />
          <LabelWithValue
            label="Activity Type"
            value={attributes?.activityType?.name}
          />
          <Divider />
          <Typography sx={{ fontWeight: "bold" }}>Input</Typography>
          <Box
            sx={{
              backgroundColor: "black",
              m: 1,
              position: "relative",
              borderRadius: 2,
              maxWidth: "60vw",
              border: "1px solid grey",
            }}
          >
            <CustomIconButton
              onClick={() => {
                handleCopy(JSON.stringify(InputData, null, 2));
              }}
            >
              <ContentCopyIcon />
            </CustomIconButton>
            <CustomBoxForInput>
              <Typography
                component="pre"
                sx={{ whiteSpace: "pre-wrap", color: "white" }}
              >
                {JSON.stringify(InputData, null, 2)}
              </Typography>
            </CustomBoxForInput>
          </Box>
          <Divider />
          <LabelWithValue
            label="Start To Close Timeout"
            value={attributes?.startToCloseTimeout}
          />
          <Divider />
          <LabelWithValue
            label="Workflow Task Completed Event ID"
            value={attributes?.workflowTaskCompletedEventId}
          />
        </Box>
      );

    case "Schedule":
      return (
        <Box>
          <LabelWithValue
            label="Schedule To Close Timeout"
            value={attributes?.scheduleToCloseTimeout}
          />
          <Divider />
          <LabelWithValue
            label="Schedule To Start Timeout"
            value={attributes?.scheduleToStartTimeout}
          />
        </Box>
      );

    case "Task Queue":
      return (
        <Box>
          <LabelWithValue
            label="Task Queue Name"
            value={attributes?.taskQueue?.name}
          />
          <Divider />
          <LabelWithValue
            label="Task Queue Kind"
            value={attributes?.taskQueue?.kind}
          />
        </Box>
      );

    case "Retry Policy":
      return (
        <Box>
          <LabelWithValue
            label="Retry Policy Initial Interval"
            value={attributes?.retryPolicy?.initialInterval}
          />
          <Divider />
          <LabelWithValue
            label="Retry Policy Backoff Coefficient"
            value={attributes?.retryPolicy?.backoffCoefficient}
          />
          <Divider />
          <LabelWithValue
            label="Retry Policy Maximum Interval"
            value={attributes?.retryPolicy?.maximumInterval}
          />
          <Divider />
          <LabelWithValue
            label="Retry Policy Maximum Attempts"
            value={
              attributes?.retryPolicy?.maximumAttempts === 0
                ? "Unlimited"
                : attributes?.retryPolicy?.maximumAttempts
            }
          />
        </Box>
      );
  }
};

export const renderActivityTaskCompleted = (attributes: any) => {
  const ResultData =
    attributes?.result?.payloads?.map((payload: { data: string }) => {
      if (!payload?.data) return payload;
      const decoded = atob(payload.data);
      try {
        return JSON.parse(decoded);
      } catch (e) {
        return decoded;
      }
    }) || [];
  return (
    <Box>
      <Typography>Result</Typography>
      <CustomBoxForOutput>
        <CustomIconButton
          onClick={() => {
            handleCopy(JSON.stringify(ResultData, null, 2));
          }}
        >
          <ContentCopyIcon />
        </CustomIconButton>
        <Typography
          component="pre"
          sx={{ whiteSpace: "pre-wrap", color: "white" }}
        >
          {JSON.stringify(ResultData, null, 2)}
        </Typography>
      </CustomBoxForOutput>
      <Divider />
      <LabelWithValue
        label="Scheduled Event ID"
        value={attributes?.scheduledEventId}
      />
      <Divider />
      <LabelWithValue
        label="Started Event ID"
        value={attributes?.startedEventId}
      />
      <Divider />
      <LabelWithValue label="Identity" value={attributes?.identity} />
    </Box>
  );
};

export const renderActivityTaskStarted = (attributes: any) => {
  return (
    <Box>
      <LabelWithValue
        label="Scheduled Event ID"
        value={attributes?.scheduledEventId}
      />
      <Divider />
      <LabelWithValue label="Identity" value={attributes?.identity} />
      <Divider />
      <LabelWithValue label="Request ID" value={attributes?.requestId} />
      <Divider />
      <LabelWithValue label="Attempt" value={attributes?.attempt} />
    </Box>
  );
};

export const RenderActivityTaskScheduled: React.FC<{attributes: any}> = ({attributes}) => {
  const [activityTaskScheduledTab, setActivityTaskScheduledTab] = useState<activityTaskScheduledTabType>("Summary");
  const handleactivityTaskScheduledTabChange = (
    event: React.SyntheticEvent,
    newValue: activityTaskScheduledTabType
  ) => {
    setActivityTaskScheduledTab(newValue);
  };
  return (
    <Box>
      <Tabs
        value={activityTaskScheduledTab}
        onChange={handleactivityTaskScheduledTabChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
      >
        <Tab value="Summary" label="Summary" />
        <Tab value="Task Queue" label="Task Queue" />
        <Tab value="Schedule" label="Schedule" />
        <Tab value="Retry Policy" label="Retry Policy" />
      </Tabs>
      <Box mt={2}>
        {renderTabContentForActivityTaskScheduledTab(
          attributes,
          activityTaskScheduledTab,
          attributes?.input?.payloads?.map(
            (payload: { data: string; }) => {
              if (!payload?.data) return "";
              const decoded = atob(payload.data);
              try {
                return JSON.parse(decoded);
              } catch (e) {
                return decoded;
              }
            }
          ) || []
        )}
      </Box>
    </Box>
  )
}

export const PendingActivityInfoSection = (
  pendingActivityInfo: V1PendingActivityInfo[]) => {
  return <Box sx={{ m: 2 }}>
  <Accordion>
    <AccordionSummary
      expandIcon={<ExpandMore />}
      aria-controls="panel1-content"
      id="panel1-header"
    >
      <Typography variant="h6">Pending Activities</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Box>
        {pendingActivityInfo.map((activity, index) => (
          <Box key={index}>
            <Box>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{index+1}</Typography>
            </Box>
            <Box sx={{display: "flex", justifyContent: "space-between"}}>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Activity Type</Typography>
                <Typography variant="body2" sx={{
                    backgroundColor: '#f8d7da',
                    color: '#a71d2a',
                    display: 'inline-block',
                    px: 1,
                    borderRadius: 1,
                  }}>
                  {activity.activityType?.name || ""}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Last Heartbeat</Typography>
                <Typography variant="body2" sx={{
                    backgroundColor: '#f8d7da',
                    color: '#a71d2a',
                    display: 'inline-block',
                    px: 1,
                    borderRadius: 1,
                  }}>
                  {activity.lastHeartbeatTime || ""}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Attempt</Typography>
                <Typography variant="body2" sx={{
                    backgroundColor: '#f8d7da',
                    color: '#a71d2a',
                    display: 'inline-block',
                    px: 1,
                    borderRadius: 1,
                  }}>
                  <Refresh />
                  {activity.attempt || ""}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Attempt Left</Typography>
                <Typography variant="body2" sx={{
                    backgroundColor: '#f8d7da',
                    color: '#a71d2a',
                    display: 'inline-block',
                    px: 1,
                    borderRadius: 1,
                  }}>
                  {"unlimited"}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Expiration</Typography>
                <Typography variant="body2" sx={{
                    backgroundColor: '#f8d7da',
                    color: '#a71d2a',
                    display: 'inline-block',
                    px: 1,
                    borderRadius: 1,
                  }}>
                  {activity.expirationTime || "No Expiration"}
                </Typography>
              </Box>
            </Box>
            <Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Last Failure</Typography>
                  <Box
                    sx={{
                      backgroundColor: "black",
                      m: 1,
                      position: "relative",
                      borderRadius: 2,
                    }}
                  >
                    <CustomIconButton
                      onClick={() => {
                        handleCopy(JSON.stringify(activity.lastFailure ? activity.lastFailure : [], null, 2));
                      }}
                      sx={{ position: "absolute", top: 8, right: 8, mr: 2 }}
                    >
                      <ContentCopyIcon />
                    </CustomIconButton>
                    <CustomInputOuputBox>
                      <Typography
                        variant="body2"
                        component="pre"
                        sx={{ color: "white" }}
                      >
                        {JSON.stringify(activity.lastFailure ? activity.lastFailure : [], null, 2)}
                      </Typography>
                    </CustomInputOuputBox>
                  </Box>
                
              </Box>
          </Box>
        ))}
      </Box>
    </AccordionDetails>
  </Accordion>
</Box>
}

export const RenderDataForSelection: React.FC<RenderCompactProps> = ({
  eventsData,
  selectedRowId,
}) => {
  const eventDataLength = eventsData.history?.events?.length || 0;
  const selectedIndex = parseInt(selectedRowId, 10);
  const events = eventsData.history?.events || [];
  
  const firstEvent =
    events[eventDataLength - selectedIndex]?.eventType ===
    "ActivityTaskScheduled"
      ? events[eventDataLength - selectedIndex]
      : undefined;

  const secoundEvent =
    events[eventDataLength - selectedIndex - 1]?.eventType ===
    "ActivityTaskStarted"
      ? events[eventDataLength - selectedIndex - 1]
      : undefined;

  const thirdEvent =
    events[eventDataLength - selectedIndex - 2]?.eventType ===
    "ActivityTaskCompleted"
      ? events[eventDataLength - selectedIndex - 2]
      : undefined;
  const fouthEvent = events[eventDataLength - selectedIndex - 2]?.eventType === "ActivityTaskFailed"
    ? events[eventDataLength - selectedIndex - 2]
    : undefined;

  const validTabs = {
    ActivityTaskScheduled: !!firstEvent,
    ActivityTaskStarted: !!secoundEvent,
    ActivityTaskCompleted: !!thirdEvent,
    ActivityTaskFailed: !!fouthEvent,
  };

  // Determine default tab selection
  const defaultTab = "ActivityTaskScheduled"

  const [dataForSelection, setDataForSelection] = useState<getOrCreateExpType>(
    defaultTab
  );

  const [activityTaskScheduledTab, setActivityTaskScheduledTab] = useState<activityTaskScheduledTabType>("Summary");

  const handleActivityTaskScheduledTabChange = (
    event: React.SyntheticEvent,
    newValue: activityTaskScheduledTabType
  ) => {
    setActivityTaskScheduledTab(newValue);
  };

  const handleGetOrCreateExpTabChange = (newValue: getOrCreateExpType) => {
    setDataForSelection(newValue);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
        }}
      >
        {/* Tabs Section */}
        <Box sx={{ width: "18%" }}>
          {validTabs.ActivityTaskCompleted && (
            <ClickableBox
              className={
                dataForSelection === "ActivityTaskCompleted" ? "selected" : ""
              }
              onClick={() =>
                handleGetOrCreateExpTabChange("ActivityTaskCompleted")
              }
            >
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                {thirdEvent
                  ? `${thirdEvent.eventId} ActivityTaskCompleted`
                  : "ActivityTaskCompleted"}
              </Typography>
            </ClickableBox>
          )}

          {validTabs.ActivityTaskFailed && (
            <ClickableBox
            className={
              dataForSelection === "ActivityTaskFailed" ? "selected" : ""
            }
            onClick={() =>
              handleGetOrCreateExpTabChange("ActivityTaskFailed")
            }
          >
            <Typography variant="body1" sx={{ fontWeight: "bold", color: "red" }}>
              {fouthEvent
                ? `${fouthEvent.eventId} ActivityTaskFailed`
                : "ActivityTaskFailed"}
            </Typography>
          </ClickableBox>
          )}
          {validTabs.ActivityTaskStarted && (
            <ClickableBox
              className={
                dataForSelection === "ActivityTaskStarted" ? "selected" : ""
              }
              onClick={() =>
                handleGetOrCreateExpTabChange("ActivityTaskStarted")
              }
            >
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                {secoundEvent
                  ? `${secoundEvent.eventId} ActivityTaskStarted`
                  : "ActivityTaskStarted"}
              </Typography>
            </ClickableBox>
          )}
          {validTabs.ActivityTaskScheduled && (
            <ClickableBox
              className={
                dataForSelection === "ActivityTaskScheduled" ? "selected" : ""
              }
              onClick={() =>
                handleGetOrCreateExpTabChange("ActivityTaskScheduled")
              }
            >
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                {firstEvent
                  ? `${firstEvent.eventId} ActivityTaskScheduled`
                  : "ActivityTaskScheduled"}
              </Typography>
            </ClickableBox>
          )}
        </Box>

        {/* Content Section */}
        <Box sx={{ width: "82%" }}>
          {dataForSelection === "ActivityTaskCompleted" && thirdEvent && (
            <Box>
              {renderActivityTaskCompleted(
                thirdEvent.activityTaskCompletedEventAttributes
              )}
            </Box>
          )}
          {dataForSelection === "ActivityTaskFailed" && fouthEvent && (
            <Box>
              {renderActivityTaskFailed(fouthEvent.activityTaskFailedEventAttributes, fouthEvent.eventTime || '')}
            </Box>
          )}
          {dataForSelection === "ActivityTaskStarted" && secoundEvent && (
            <Box>
              {renderActivityTaskStarted(
                secoundEvent.activityTaskStartedEventAttributes
              )}
            </Box>
          )}
          {dataForSelection === "ActivityTaskScheduled" && firstEvent && (
            <Box>
              <Tabs
                value={activityTaskScheduledTab}
                onChange={handleActivityTaskScheduledTabChange}
                textColor="secondary"
                indicatorColor="secondary"
                aria-label="secondary tabs example"
              >
                <Tab value="Summary" label="Summary" />
                <Tab value="Task Queue" label="Task Queue" />
                <Tab value="Schedule" label="Schedule" />
                <Tab value="Retry Policy" label="Retry Policy" />
              </Tabs>
              <Box mt={2}>
                {renderTabContentForActivityTaskScheduledTab(
                  firstEvent.activityTaskScheduledEventAttributes,
                  activityTaskScheduledTab,
                  firstEvent?.activityTaskScheduledEventAttributes?.input?.payloads?.map(
                    (payload) => {
                      if (!payload?.data) return payload;
                      const decoded = atob(payload.data);
                      try {
                        return JSON.parse(decoded);
                      } catch (e) {
                        return decoded;
                      }
                    }
                  ) || []
                )}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export const columnsRun: Column[] = [
  {
    id: "status",
    label: "Status",
    render: (value: any) => {
      let chipColor:
        | "primary"
        | "secondary"
        | "warning"
        | "success"
        | "error"
        | "info" = "info";
      console.log(value);
      console.log(
        V1WorkflowExecutionStatus.WORKFLOW_EXECUTION_STATUS_COMPLETED
      );
      switch (value.toLowerCase()) {
        case V1WorkflowExecutionStatus.WORKFLOW_EXECUTION_STATUS_COMPLETED.toLowerCase():
          chipColor = "success";
          break;
        case V1WorkflowExecutionStatus.WORKFLOW_EXECUTION_STATUS_FAILED.toLowerCase():
          chipColor = "error";
          break;
        case V1WorkflowExecutionStatus.WORKFLOW_EXECUTION_STATUS_RUNNING.toLowerCase():
          chipColor = "info";
          break;
        case V1WorkflowExecutionStatus.WORKFLOW_EXECUTION_STATUS_CANCELED.toLowerCase():
          chipColor = "warning";
          break;
        case V1WorkflowExecutionStatus.WORKFLOW_EXECUTION_STATUS_TERMINATED.toLowerCase():
          chipColor = "error";
          break;
        case V1WorkflowExecutionStatus.WORKFLOW_EXECUTION_STATUS_TIMED_OUT.toLowerCase():
          chipColor = "primary";
          break;
        case V1WorkflowExecutionStatus.WORKFLOW_EXECUTION_STATUS_CONTINUED_AS_NEW.toLowerCase():
          chipColor = "info";
          break;
        case V1WorkflowExecutionStatus.WORKFLOW_EXECUTION_STATUS_UNSPECIFIED.toLowerCase():
          chipColor = "info";
          break;
      }
      return <Chip label={value} size="small" color={chipColor} />;
    },
  },
  { id: "workflowId", label: "Workflow ID", type: "string" },
  { id: "runId", label: "Run ID", type: "string" },
  { id: "type", label: "Type", type: "string" },
  { id: "taskQueue", label: "Task Queue", type: "string" },
  { id: "executionTime", label: "Execution Time", type: "datetime" },
  { id: "startTime", label: "Start Time", type: "datetime" },
  { id: "closeTime", label: "Close Time", type: "datetime" },
  { id: "historyLength", label: "History Length", type: "numeric" },
  {
    id: "stateTransitionCount",
    label: "State Transition Count",
    type: "numeric",
  },
  { id: "historySizeBytes", label: "History Size Bytes", type: "numeric" },
  { id: "parentNamespaceId", label: "Parent Namespace ID", type: "string" },
  { id: "parentworkflowId", label: "Parent Workflow ID", type: "string" },
  { id: "parentRunId", label: "Parent Run ID", type: "string" },
];
